import { makeStyles, tokens } from "@fluentui/react-components";

export const usePlaybookRuleCardStyles = makeStyles({
  name: {
    fontWeight: "bold",
  },
  card: {
    gap: 0,
    padding: "1.5rem",
    backgroundColor: tokens.colorNeutralBackground2Selected,
  },
  panel: {
    marginTop: "0.75rem",
  },
  panelHeader: {
    padding: 0,
    minHeight: "unset",
  },
  ruleIcon: {
    transform: "scaleX(-1)",
  },
  ruleDescription: {
    whiteSpace: "pre-line",
  },
  ruleExample: {
    paddingLeft: "1.25rem",
    whiteSpace: "pre-line",
  },
});
